/**
 * Notice — a short message on a tinted ground (an error with its Try again,
 * "Couldn't refresh"). The words carry the meaning; the tone tints the ground
 * and marks the left edge. Same piece and props as the app's Notice
 * (apps/mobile/src/components/common/ds). `danger` is announced (role alert).
 */
import React from 'react';
import { textRole, tokenVars } from '@turn-connect/ui';

export type NoticeTone = 'danger' | 'warning' | 'info' | 'success' | 'neutral';

export interface NoticeProps {
  tone?: NoticeTone;
  testId?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

/** Each tone's ground, text and edge (exported for tests). */
export const NOTICE_LOOK: Record<NoticeTone, { bg: string; fg: string; edge: string }> = {
  danger: { bg: tokenVars.dangerSubtle, fg: tokenVars.dangerText, edge: tokenVars.danger },
  warning: { bg: tokenVars.warningSubtle, fg: tokenVars.warningText, edge: tokenVars.warning },
  info: { bg: tokenVars.infoSubtle, fg: tokenVars.text.primary, edge: tokenVars.info },
  success: { bg: tokenVars.successSubtle, fg: tokenVars.text.primary, edge: tokenVars.success },
  neutral: { bg: tokenVars.surfaceMuted, fg: tokenVars.text.secondary, edge: tokenVars.border },
};

export const Notice: React.FC<NoticeProps> = ({ tone = 'neutral', testId, style, children }) => {
  const l = NOTICE_LOOK[tone];
  return (
    <div
      role={tone === 'danger' ? 'alert' : undefined}
      data-testid={testId}
      style={{
        ...textRole('body', l.fg),
        background: l.bg,
        borderLeft: `3px solid ${l.edge}`,
        borderRadius: 6,
        padding: '8px 12px',
        overflowWrap: 'anywhere',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Notice;
